import type { Session } from '@innovamat/ga-features';
import type { TFunction } from 'i18next';
import 'tippy.js/dist/tippy.css';
import type { ImageModal } from './components/ImagesModal/ImagesModal';
import { PlayerBlock } from './components/PlayerBlock';
import EarlyYearDigitalGuideWrapper from './templates/EarlyYear/EarlyYear';
import EarlyYearClassroomLifeWrapper from './templates/EarlyYear/EarlyYearClassroomLife';
import type { ChallengesResponse } from './templates/EarlyYear/types/challenges';
import SecondaryDigitalGuideWrapper from './templates/Secondary';
import type { DigitalGuide } from './types/digital-guide';
import type { ScrollPosition } from './types/prepr';

type Props = {
  canMarkAsDone?: boolean;
  challenges?: ChallengesResponse | undefined;
  guide: DigitalGuide;
  images: ImageModal[];
  isStudent: boolean;
  regionParameters?: any;
  resource: Session;
  scrollPosition: ScrollPosition;
  unblockedAppletsComponent?: React.ReactNode;
  onEvent: (key: string, data: any) => void;
  onMarkChallengeAsDone?: (challengeId: string, value: boolean) => void;
  t: TFunction<'translation', undefined, 'translation'>;
};

function DigitalGuideWrapper({
  canMarkAsDone,
  challenges,
  guide,
  images,
  isStudent,
  regionParameters,
  resource,
  scrollPosition,
  unblockedAppletsComponent,
  onEvent,
  onMarkChallengeAsDone,
  t,
}: Props) {
  switch (guide.preprType) {
    case 'earlyYear':
      return (
        <EarlyYearDigitalGuideWrapper
          challenges={challenges}
          guide={guide}
          images={images}
          canMarkAsDone={canMarkAsDone}
          resource={resource}
          onMarkChallengeAsDone={onMarkChallengeAsDone}
          scrollPosition={scrollPosition}
          onEvent={onEvent}
          t={t}
        />
      );
    case 'earlyYearClassroomLife':
      return (
        <EarlyYearClassroomLifeWrapper
          challenges={challenges}
          guide={guide}
          images={images}
          canMarkAsDone={canMarkAsDone}
          resource={resource}
          onMarkChallengeAsDone={onMarkChallengeAsDone}
          scrollPosition={scrollPosition}
          onEvent={onEvent}
          t={t}
        />
      );
    case 'secondary':
      if (isStudent) {
        return (
          <>
            <PlayerBlock />
            <div data-zone="unblocked-applets">{unblockedAppletsComponent}</div>
          </>
        );
      }
      return (
        <SecondaryDigitalGuideWrapper
          regionParameters={regionParameters}
          guide={guide}
          images={images}
          resource={resource}
          scrollPosition={scrollPosition}
          onEvent={onEvent}
          t={t}
        />
      );
    default:
      return null;
  }
}

export { DigitalGuideWrapper };
